import { DownloadedDamageMatrix, DownloadedUpgradesMatrix, DownloadedValuesMatrix, } from "./downloadeddata";
import { SubMenu } from "./enums";
import Game from "./game";
import game, { riverDamageLevel, seaZone, natureBasedProtectionLevel, getRiverStage, getTotalStormLevel } from "./game";
import playerState from "./playerstate";
import property_part from "./property_part";
import property_part_css from "./property_part_css";
import propertyPartState from "./propertyPartState";
import propertyState from "./propertyState";

export const properties: { [id: string]: property } = {};

let damageMatrix: DownloadedDamageMatrix[] = [];
let valuesMatrix: DownloadedValuesMatrix[] = [];
let upgradesMatrix: DownloadedUpgradesMatrix[] = [];

export function isInMarae(playerState: playerState | null): boolean {
    if (!playerState) {
        return false;
    }
    return playerState.livedInProperty == marae.key;
}

export function isOnFarm(playerState: playerState | null): boolean {
    if (!playerState) {
        return false;
    }

    switch (playerState.livedInProperty) {
        case farm1.key:
        case farm2.key:
        case atRiskFarm1.key:
        case atRiskFarm2.key:
            return true;
    }

    return false;
}

export function doIOwnThisProperty(propertyData: property, playerState: playerState): boolean {

    for (const propertyState of playerState.properties) {
        if (propertyState.property == propertyData.key) {
            //I own this myself
            return true;
        }
    }
    return false;

}

export function doesAnyoneOwnThisProperty(propertyData: property, gameState: game): boolean {

    for (const state of Object.values(gameState.playerStates)) {
        for (const propertyState of state.properties) {
            if (propertyState.property == propertyData.key) {
                //Someone (maybe not me) owns this
                return true;
            }
        }
    }
    return false;

}

export function canBuyOrSellProperty(subMenu: SubMenu, propertyData: property, playerState: playerState): boolean {

    //This is not a house we can move into anyway
    if (getBuyCost(propertyData) == 0) {
        return false;
    }

    /*    
    switch (subMenu) {

        case SubMenu.sellAndMoveElsewhere:
        case SubMenu.sellAndMove:

            if (ownsAnyAtRiskInvestments(playerState)) {
                //We can't move into an at risk house if we own any as an investment
                if (isSafeHouse(propertyData) == false) {
                    return false;
                }
            }

            break;

        /*
    case SubMenu.buyInvestmentProperty:

        //We can't buy any properties with an investment if their rental cost is zero
        if (getRentCost(propertyData) == 0) {
            return false;
        }

        //ALSO - if this is NOT a safe house, we can only buy as an investment if we're living in a safe house
        if (isSafeHouse(propertyData) == false) {

            if (isLivingInAtRiskProperty(playerState) || ownsAnyAtRiskInvestments(playerState)) {
                return false;
            }
        }
        break;

    case SubMenu.sellInvestmentProperty:
        if (getRentCost(propertyData) == 0) {
            return false;
        }
        break;
    }
    */

    return true;

}

/*
export function ownsAnyAtRiskInvestments(playerState: playerState): boolean {
    for (const property of playerState.properties) {
        //We don't care about the house we're actually living in
        if (property.property == playerState.livedInProperty) {
            continue;
        }

        //If this is not the house we live in, then it must be an investment
        if (isSafeHouse(properties[property.property]) == false) {
            return true;
        }
    }
    return false;
}
*/

export function isLivingInAtRiskProperty(playerState: playerState): boolean {
    return isSafeHouse(properties[playerState.livedInProperty]) == false;
}

export function setDamageMatrix(data: DownloadedDamageMatrix[]) {
    for (const matrix of data) {
        damageMatrix.push(matrix);
    }
}

export function setValuesMatrix(data: DownloadedValuesMatrix[]) {
    for (const matrix of data) {
        if (!matrix.Property) {
            break;
        }
        valuesMatrix.push(matrix);
    }
}

export function setUpgradesMatrix(data: DownloadedUpgradesMatrix[]) {
    for (const matrix of data) {
        upgradesMatrix.push(matrix);
    }
}

export function getUpgradeMatrix(propertyPart: property_part): DownloadedUpgradesMatrix | null {
    for (const matrix of upgradesMatrix) {

        if (matrix.Subproperty == propertyPart.damageClass) {
            return matrix
        }
    }
    return null;
}

export function getValuesMatrix(property: property): DownloadedValuesMatrix | null {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return matrix;
        }
    }
    return null;
}

export function getMoveTurns(propertyPart: property_part): number {

    for (const matrix of upgradesMatrix) {

        if (matrix.Subproperty == propertyPart.damageClass) {
            return parseInt(matrix.MoveTurns, 10);
        }
    }

    return 0;
}

export function getMoveCost(propertyPart: property_part): number {
    for (const matrix of upgradesMatrix) {
        if (matrix.Subproperty == propertyPart.damageClass) {
            return parseInt(matrix.MoveCost, 10);
        }
    }
    return 0;
}

export function getRaiseCost(propertyPart: property_part): number {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return 0;
    }

    return parseInt(matrix.RaiseCost, 10);

}

export function getRaiseButtonText(T: (key: string) => string, propertyPart: property_part): string {
    for (const matrix of upgradesMatrix) {
        if (matrix.Subproperty == propertyPart.damageClass) {
            return T(matrix.RaiseButtonText);
        }
    }
    return "";
}

export function getRaiseReportText(T: (key: string) => string, propertyPart: property_part): string {
    for (const matrix of upgradesMatrix) {
        if (matrix.Subproperty == propertyPart.damageClass) {
            return T(matrix.RaiseReportText);
        }
    }
    return "";
}


export function getRaiseSelectionText(T: (key: string) => string, propertyPart: property_part): string {
    for (const matrix of upgradesMatrix) {
        if (matrix.Subproperty == propertyPart.damageClass) {
            return T(matrix.RaiseSelectionText);
        }
    }
    return "";
}

export function getRaisePost(T: (key: string) => string, propertyPart: property_part): string {
    for (const matrix of upgradesMatrix) {
        if (matrix.Subproperty == propertyPart.damageClass && matrix.RaisePostText) {
            return T(matrix.RaisePostText);
        }
    }
    return "";
}

export function getBuyInvestmentPropertyButton(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.InvestButtonText);
        }
    }
    return "";
}

export function getBuyInvestmentPropertyText(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.InvestSelectionText);
        }
    }
    return "";
}

export function getBuyInvestmentPropertyReport(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.InvestReportText);
        }
    }
    return "";
}

export function getSellPropertyButton(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.SellAndMoveButtonText);
        }
    }
    return "";
}

export function getSellPropertyReport(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.SellAndMoveReportText);
        }
    }
    return "";
}

export function getSellInvestmentPropertyReport(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.SellInvestmentReportText);
        }
    }
    return "";
}


export function getSellPropertyText(T: (key: string) => string, property: property): string {

    for (const matrix of valuesMatrix) {
        if (matrix.Property == property.classKey) {
            return T(matrix.SellAndMoveSelectionText);
        }
    }
    return "";
}

export function getMoveButtonText(T: (key: string) => string, playerState: playerState, propertyPart: property_part, propertyPartState: propertyPartState): string {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return "";
    }

    if (propertyPartIsUnderwater(playerState, propertyPart, propertyPartState)) {
        return T(matrix.SalvageButtonText);
    }
    return T(matrix.MoveButtonText);

}

export function getMoveReportText(T: (key: string) => string, playerState: playerState, propertyPart: property_part, propertyPartState: propertyPartState): string {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return "";
    }

    if (propertyPartIsUnderwater(playerState, propertyPart, propertyPartState)) {
        return T(matrix.SalvageReportText);
    }
    return T(matrix.MoveReportText);

}

export function getMoveSelectionText(T: (key: string) => string, playerState: playerState, propertyPart: property_part, propertyPartState: propertyPartState): string {
    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return "";
    }

    if (propertyPartIsUnderwater(playerState, propertyPart, propertyPartState)) {
        return T(matrix.SalvageSelectionText);
    }
    return T(matrix.MoveSelectionText);
}

export function getMovePost(T: (key: string) => string, playerState: playerState, propertyPart: property_part, propertyPartState: propertyPartState): string {
    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return "";
    }

    if (propertyPartIsUnderwater(playerState, propertyPart, propertyPartState)) {
        return T(matrix.SalvagePostText);
    }
    return T(matrix.MovePostText);
}

export function cowShedIsDamaged(playerState: playerState): boolean {

    //Foreach property the player owns
    for (const propertyState of playerState.properties) {

        const property = properties[propertyState.property];

        //Foreach part of this property
        for (let i = 0; i < property.property_parts.length; i++) {

            //We own a cowshed
            if (getIsCowshed(property.property_parts[i])) {

                //And the cowshed is damaged
                if (propertyState.propertyPartStates[i].repairCost) {
                    return true;
                }
            }

        }

    }

    return false;

}

function getIsCowshed(propertyPart: property_part): boolean {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return false;
    }
    return matrix.IsCowshed.trim().toLowerCase() == "yes";

}


export function getNatureBasedMove(propertyPart: property_part): boolean {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return false;
    }
    return matrix.NatureBasedRequiresMove.trim().toLowerCase() == "yes";

}

export function getNatureBasedRaise(propertyPart: property_part): boolean {

    const matrix = getUpgradeMatrix(propertyPart);
    if (!matrix) {
        return false;
    }
    return matrix.NatureBasedRequiresRaise.trim().toLowerCase() == "yes";

}


export function getDefaultRevenue(property: property) {
    let propertyValues = getValuesMatrix(property);
    if (!propertyValues) {
        return 0;
    }

    return parseInt(propertyValues.Revenue_NoEvent, 10);
}

//, isLivedIn: boolean
export function getRoundRevenue(game: Game, property: property, playerState: playerState): number {

    let propertyValues = getValuesMatrix(property);
    if (!propertyValues) {
        return 0;
    }

    //Get the base result
    let result = 0;
    const riverState = getRiverStage(game, playerState);
    if (playerState.natureBasedState == 2) { //Nature based is fully grown
        switch (riverState) {
            case 0:
                result = parseInt(propertyValues.Revenue_NoEvent_NatureBased, 10);
                break;
            case 1:
                result = parseInt(propertyValues.Revenue_HighFlood_NatureBased, 10);
                break;
            case 2:
                result = parseInt(propertyValues.Revenue_SevereFlood_NatureBased, 10);
                break;
        }
    }
    else {
        switch (riverState) {
            case 0:
                result = parseInt(propertyValues.Revenue_NoEvent, 10);
                break;
            case 1:
                result = parseInt(propertyValues.Revenue_HighFlood, 10);
                break;
            case 2:
                result = parseInt(propertyValues.Revenue_SevereFlood, 10);
                break;
        }
    }

    //How much is the ground water eating into our revenue
    const groundWater = groundWaterZone(playerState, true);
    let groundWaterIncursion = groundWater - parseInt(propertyValues.Zone, 10);

    if (groundWaterIncursion < 0) {
        //Hasn't reached the farm yet
        result -= 0;
    }
    else if (groundWaterIncursion == 0) {
        //First zone
        result -= parseInt(propertyValues.RevenueLoss_Groundwater_1, 10)
    }
    else if (groundWaterIncursion == 1) {
        //Second zone
        result -= parseInt(propertyValues.RevenueLoss_Groundwater_2, 10)
    }
    else {
        //Third zone onwards
        result -= parseInt(propertyValues.RevenueLoss_Groundwater_3, 10)
    }

    //Do we own a pump?
    for (const propertyState of playerState.properties) {

        //Only care about the currently lived in property
        if (propertyState.property != playerState.livedInProperty) {
            continue;
        }

        //If we don't have a drainage pump, do nothing
        if (propertyState.hasDrainagePump == false) {
            continue;
        }

        result -= parseInt(propertyValues.Groundwater_Pump_Ongoing_Cost, 10);
    }

    //Make sure we do not have a NEGATIVE revenue from all of the farm costs
    if (result < 0) {
        result = 0;
    }
    return result;
}

export function getStopBankCost(playerState: playerState, seaWallHeight: number, zeroIfBuilt: boolean, governmentSubsidy: boolean): number {

    let propertyData = properties[playerState.livedInProperty];
    let propertyValues = getValuesMatrix(propertyData);
    if (!propertyValues) {
        return 0;
    }

    switch (seaWallHeight) {
        case 2:
            if (zeroIfBuilt && playerState.seaWallHeight > 1) {
                return 0;
            }

            if (governmentSubsidy) {
                return parseInt(propertyValues.Seawall2Subsidy, 10);
            }
            else {
                return parseInt(propertyValues.Seawall2, 10);
            }

        case 1:

            if (zeroIfBuilt && playerState.seaWallHeight > 1) {
                return 0;
            }

            if (governmentSubsidy) {
                return parseInt(propertyValues.Seawall1Subsidy, 10);
            }
            else {
                return parseInt(propertyValues.Seawall1, 10);
            }

        default:

            if (zeroIfBuilt && playerState.stopBank) {
                return 0;
            }

            if (governmentSubsidy) {
                return parseInt(propertyValues.BuyStopBankSubsidy, 10);
            }
            else {
                return parseInt(propertyValues.BuyStopBank, 10);
            }
    }

}

export function getPumpCost(playerState: playerState, zeroIfBuilt: boolean): number {

    //Check if we already HAVE a pump at our lived in property
    if (zeroIfBuilt) {
        for (const propertyState of playerState.properties) {

            if (propertyState.property != playerState.livedInProperty) {
                continue;
            }

            if (propertyState.hasDrainagePump) {
                return 0;
            }
        }
    }

    const property = properties[playerState.livedInProperty];
    const values = getValuesMatrix(property);
    if (!values) {
        return 0;
    }

    return parseInt(values.Groundwater_Pump_Initial_Cost, 10);
}

export function getNatureBasedCost(playerState: playerState, sea: boolean, governmentSubsidy: boolean): number {

    let result = 0;

    for (const property of playerState.properties) {

        if (playerState.livedInProperty != property.property) {
            continue;
        }

        let propertyData = properties[playerState.livedInProperty];
        let propertyValues = getValuesMatrix(propertyData);
        if (!propertyValues) {
            return 0;
        }


        if (sea) {

            if (governmentSubsidy) {
                return parseInt(propertyValues.BuyNatureBasedSeaSubsidy, 10);
            }
            else {
                return parseInt(propertyValues.BuyNatureBasedSea, 10);
            }
        }
        else {

            if (governmentSubsidy) {
                result = parseInt(propertyValues.BuyNatureBasedSubsidy, 10);
            }
            else {
                result = parseInt(propertyValues.BuyNatureBased, 10);
            }

            for (let i = 0; i < propertyData.property_parts.length && i < property.propertyPartStates.length; i++) {
                let propertyPartData = propertyData.property_parts[i];
                let propertyPartState = property.propertyPartStates[i];

                //Add the nature based move cost - IF we haven't already moved
                if (propertyPartState.isMoving == false
                    && getNatureBasedMove(propertyPartData)) {
                    result += getMoveCost(propertyPartData);
                }

                //Add the nature based raise cost
                if (propertyPartState.hasRaisedFloor[propertyPartState.movePosition] == false
                    && getNatureBasedRaise(propertyPartData)) {
                    result += getRaiseCost(propertyPartData);
                }
            }
        }

    }

    return result;

}

export function getBuyCost(property: property): number {
    let propertyValues = getValuesMatrix(property);
    if (!propertyValues) {
        return 0;
    }
    return parseInt(propertyValues.Buy, 10);
}

export function isSafeHouse(property: property): boolean {
    const propertyValues = getValuesMatrix(property);
    if (!propertyValues) {
        return false;
    }
    return propertyValues.IsSafe.trim().toLowerCase() == "yes";
}

/*
export function getRentCost(property: property): number {
    const propertyValues = requestPropertyValues(property);
    if (!propertyValues) {
        return 0;
    }
    return parseInt(propertyValues.Rent, 10);
}
*/

export function ownedPropertyValue(playerState: playerState): number {
    let result = 0;
    for (const propertyState of playerState.properties) {
        result += getSellCost(playerState, propertyState);
    }
    return result;
}

export function getSellCost(playerState: playerState, propertyState: propertyState): number {

    const property = properties[propertyState.property];
    let propertyValues = getValuesMatrix(property);
    if (!propertyValues) {
        return 0;
    }

    let baseCost = parseInt(propertyValues.SellUndamaged, 10);
    if (propertyState.damageLevel == riverDamageLevel.severeFlood) {
        baseCost = parseInt(propertyValues.SellSevereFloodDamage, 10);
    }
    else if (propertyState.damageLevel == riverDamageLevel.highFlood) {
        baseCost = parseInt(propertyValues.SellHighFloodDamage, 10);
    }
    else if (playerState.stopBank) {
        baseCost = parseInt(propertyValues.SellUndamagedAndStopBank, 10);
    }
    return processCost(baseCost, playerState, propertyValues);

}



export function groundWaterZone(playerState: playerState, includeGroundwaterProtection: boolean): number {

    //Groundwater is always one ahead of the round number
    let result = playerState.round + 1;

    //If we're including ground water protection, subtract until the boundaries of the property
    if (includeGroundwaterProtection) {

        for (const propertyState of playerState.properties) {

            //Only care about the currently lived in property
            if (propertyState.property != playerState.livedInProperty) {
                continue;
            }

            //If we don't have a drainage pump, do nothing
            if (propertyState.hasDrainagePump == false) {
                continue;
            }

            const property = properties[propertyState.property];
            const matrix = getValuesMatrix(property);
            if (!matrix) {
                continue;
            }

            //The drainage pump provides two zones of protection, but does NOT drain past the boundaries of the property
            const boundaryZone = parseInt(matrix.Zone, 10) - 1;
            if (result > boundaryZone) {
                result = Math.max(result - 2, boundaryZone);
            }


        }

    }

    return result;

}


function processCost(baseCost: number, playerState: playerState, propertyValues: DownloadedValuesMatrix): number {

    const zone = parseInt(propertyValues.Zone, 10);

    //If this property is safe from all Sea Level Rise, do nothing
    if (!zone) {
        return baseCost;
    }

    const boundary = zone - 1;
    const currentSeaZone = seaZone(playerState, true);
    const currentGroundWaterZone = groundWaterZone(playerState, true);

    if (currentSeaZone >= zone) {
        //Seawater is inside the property
        return baseCost * parseFloat(propertyValues.SeaWaterInProperty);
    }
    if (currentSeaZone >= boundary) {
        //Seawater is inside the property
        return baseCost * parseFloat(propertyValues.SeaWaterAtBoundary);
    }
    else if (currentGroundWaterZone >= zone) {
        //There is groundwater in this property
        return baseCost * parseFloat(propertyValues.GroundWaterInProperty);
    }
    else if (currentGroundWaterZone >= boundary) {
        //There is ground water at the boundary
        return baseCost * parseFloat(propertyValues.GroundWaterAtBoundary);
    }

    //This house is not at danger from SLR yet
    return baseCost;

}

export function getLivedInPropertyState(playerState: playerState): propertyState | null {
    for (const property of playerState.properties) {
        if (playerState.livedInProperty === property.property) {
            return property;
        }
    }
    return null;
}

export function anySalvagablePropertyPart(playerState: playerState): boolean {

    const property = properties[playerState.livedInProperty];
    const propertyState = getLivedInPropertyState(playerState);
    if (!propertyState) {
        return false;
    }

    for (let i = 0; i < property.property_parts.length; i++) {

        const propertyPart = property.property_parts[i];
        const propertyPartState = propertyState.propertyPartStates[i];

        //There's no option to move this part anyway
        if (getMoveCost(propertyPart) == 0) {
            continue;
        }

        //The part is already moved or moving
        if (propertyPartState.isMoving) {
            continue;
        }

        if (propertyPartIsUnderwater(playerState, propertyPart, propertyPartState)) {
            //This specific property part is under water!
            return true;
        }

    }

    return false;
}

export function propertyPartIsUnderwater(playerState: playerState, part: property_part, propertyPartState: propertyPartState, nextRound: boolean = false): boolean {

    const zone = getPropertyPartZone(part, propertyPartState);

    //Safe so can't possibly be underwater
    if (zone == 0) {
        return false;
    }

    //Is the player's property partly covered by the sea?
    const currentSeaZone = seaZone(playerState, true, -1, nextRound);
    return currentSeaZone >= zone;

}

//returns the adjusted zone for this property
export function getPropertyPartZone(part: property_part, propertyPartState: propertyPartState): number {

    const matrix = getUpgradeMatrix(part);
    //Can't find information about this part's zone    
    if (!matrix) {
        return 0;
    }

    //Get the sea zone
    let zone = 0;
    if (propertyPartState.isMoving) {
        zone = parseInt(matrix.ZoneWhenMoved, 10);
    }
    else {
        zone = parseInt(matrix.Zone, 10);
    }

    //This property is safe
    if (!zone) {
        return 0;
    }

    //If we're not in the safe zone, give a boost of 1 if we're raised in the CURRENT position
    if (propertyPartState.hasRaisedFloor[propertyPartState.movePosition]) {
        zone += 1;
    }

    return zone;

}

export function requestSeaPropertyDamage(game: game, playerState: playerState, part: property_part, propertyPartState: propertyPartState): number {

    //Return 0 if this isn't actually a damage key
    if (!part.damageClass) {
        return 0;
    }

    //If we still have the nature based sea solution (wasn't destroyed by cyclone) we're protected from all sea floods
    if (playerState.natureBasedSeaSolution) {
        return 0;
    }

    const matrix = getUpgradeMatrix(part);
    if (!matrix) //Can't find information about how this part upgrades
    {
        return 0;
    }

    const isRaised = propertyPartState.hasRaisedFloor[propertyPartState.movePosition];

    for (const data of damageMatrix) {

        //Does this match the property type?
        if (data.Subproperty != part.damageClass) {
            continue;
        }

        //Is this raised or not?
        if (isRaised != (data.Raised == "Yes")) {
            continue;
        }

        //Use the "moved==false" version of the data
        if (data.Moved == "Yes") {
            continue;
        }

        const zone = getPropertyPartZone(part, propertyPartState);

        //Is in safe zone currently
        if (!zone) {
            return 0;
        }

        const stormLevel = getTotalStormLevel(game, playerState);
        if (stormLevel >= zone) {

            let returnResult = parseInt(data.RepairCostSeaDamage, 10);

            //Sanity check - prevent 0 at all costs
            if (isNaN(returnResult)) {
                return 0;
            }

            return returnResult;
        }

        return 0;
    }

    return 0;

}

export function requestRiverPropertyDamage(game: game, playerState: playerState, part: property_part, propertyPartState: propertyPartState): number {

    //Return 0 if this isn't actually a damage key
    if (!part.damageClass) {
        return 0;
    }

    //If we still have the stop bank (wasn't destroyed by severe) we're protected from all river floods
    if (playerState.stopBank) {
        return 0;
    }

    //No damage from river
    if (getRiverStage(game, playerState) == riverDamageLevel.none) {
        return 0;
    }

    const isMoved = propertyPartState.movePosition && propertyPartState.movePosition >= getMoveTurns(part);
    const isRaised = propertyPartState.hasRaisedFloor[propertyPartState.movePosition];
    const hasNatureBasedSolution = playerState.natureBasedState >= natureBasedProtectionLevel;
    const isSevere = getRiverStage(game, playerState) == riverDamageLevel.severeFlood;

    for (const data of damageMatrix) {

        //Does this match the property type?
        if (data.Subproperty != part.damageClass) {
            continue;
        }

        //Is this moved or not?
        if (isMoved != (data.Moved == "Yes")) {
            continue;
        }

        //Is this raised or not?
        if (isRaised != (data.Raised == "Yes")) {
            continue;
        }

        //Are we nature based protected?
        if (hasNatureBasedSolution != (data.NatureBasedProtection == "Yes")) {
            continue;
        }

        //Are we stop bank protected
        /*
        if (hasStopBank != (data.Stopbank == "Yes")) {
            continue;
        }
            */

        //This is the combination that we're looking for
        let result = isSevere ? data.RepairCostSevere : data.RepairCostHigh;

        let returnResult = parseInt(result, 10);

        //Sanity check - prevent 0 at all costs
        if (isNaN(returnResult)) {
            return 0;
        }

        return returnResult;

    }

    return 0;

}

function addProperty(property: property) {
    properties[property.key] = property;
}

export enum propertyBuyModes {
    cantBuy = 0,
    moveOnly = 1,
    investment = 2,
}

export default interface property {

    key: string;
    property_parts: property_part[];

    buySelected: boolean;
    //    caravanClass: string; hard coded as "caravan" for now
    //    mustSellToBank: boolean; //Must sell to bank IF we're unable to repair
    elsewhere: boolean; //Show in the "elsewhere" menu if buying

    classKey: string;
}

//Player one's default place
export const townsFolkHouseOrange: property = {
    buySelected: false,
    elsewhere: false,
    key: "townsFolkHouseOrange",
    classKey: "townsFolkHouse",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "townsFolkHouse",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("house-orange", 865 - 106, 424 + 6, 43, 29)
                    .raise("house-orange-raised", 8).move_relative(52, 0).damage_class()
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("townsperson-outline-1", 810.89 - 109, 437.3, 203, 18).requiresOwnership(),
            ],
        },
    ]
}
addProperty(townsFolkHouseOrange);


//Player two's default place
export const townsFolkHouseBlue: property = {
    buySelected: false,
    elsewhere: false,
    key: "townsFolkHouseBlue",
    classKey: "townsFolkHouse",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "townsFolkHouse",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("house-blue", 814 - 106, 442 + 6, 43, 29)
                    .raise("house-blue-raised", 8).move_relative(134, 0).damage_class()
                //                    .add_sale_sign(1000, 49, 13)
            ],
        },


        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("townsperson-outline-2", 800 - 109, 453.3, 203, 19).requiresOwnership(),
            ],
        },

    ]
}
addProperty(townsFolkHouseBlue);

export const safeHouseLifestyle: property = {
    buySelected: false,
    elsewhere: false,
    key: "safeHouseLifestyle",
    classKey: "safeHouseLifestyle",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("safe-house-lifestyle", 1080 - 109, 229, 68.1, 26)
                    .add_sale_sign(2000, 1044 - 1080, 237 - 229).damage_class()
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("lifestyle-outline", 1048.86 - 109, 228, 110, 46).requiresOwnership(),
            ],
        },

    ]
}
addProperty(safeHouseLifestyle);

export const safeHouseLuxury: property = {
    buySelected: false,
    elsewhere: false,
    key: "safeHouseLuxury",
    classKey: "safeHouseLuxury",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("safe-house-luxury", 486 - 109, 175, 75.47, 21)
                    .add_sale_sign(2000, 427 - 486, 181 - 175).damage_class()
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("luxury-outline", 413.5 - 109, 187, 193, 39).requiresOwnership(),
            ],
        },
    ]
}
addProperty(safeHouseLuxury);

export const lowRiskRiversideHome: property = {
    buySelected: false,
    elsewhere: false,
    key: "lowRiskRiversideHome",
    classKey: "lowRiskRiversideHome",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "lowRiskRiversideHome",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("medium-family-home", 605 - 109, 177 + 6, 63, 34)
                    .raise("medium-family-home-raised", 8)
                    .add_sale_sign(1200, 567 - 605, 190 - (177 + 6)).damage_class()
            ],

        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("lowrisk-outline", 567.5 - 109, 188.5, 129, 42).requiresOwnership(),
            ],
        },
    ]
}
addProperty(lowRiskRiversideHome);

export const atRiskRiversideHome: property = {
    buySelected: false,
    elsewhere: false,
    key: "atRiskRiversideHome",
    classKey: "atRiskRiversideHome",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "atRiskRiversideHome",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("house-orange", 630 - 106, 226 + 6, 43, 29)
                    .raise("house-orange-raised", 8).move_relative(52, 0)
                    .add_sale_sign(1000, 666 - 630, 203 - (226 + 6)).damage_class()
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("atrisk-outline", 604.5 - 109, 222.5, 114, 42).requiresOwnership(),
            ],
        },
    ]
}
addProperty(atRiskRiversideHome);

export const atRiskFamilyHome: property = {
    buySelected: false,
    elsewhere: false,
    key: "atRiskFamilyHome",
    classKey: "atRiskFamilyHome",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "atRiskFamilyHome",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("medium-family-home-teal", 1052 - 109, 286 + 6, 63, 34)
                    .raise("medium-family-home-teal-raised", 8)
                    .add_sale_sign(1200, 999 - 1052, 301 - (286 + 6)).damage_class()
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("family-outline", 997.93 - 109, 305, 124, 32).requiresOwnership(),
            ],
        },
    ]
}
addProperty(atRiskFamilyHome);

//Farmers and townsfolk are forced to move here if their property is covered in water
export const relatives: property = {
    buySelected: false,
    elsewhere: true,
    key: "relatives",
    classKey: "relatives",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("", 250 - 95, 101 + 54, 44, 54)
            ],
        }
    ]
}
addProperty(relatives);

export const townhouse: property = {
    buySelected: false,
    elsewhere: true,
    key: "townhouse",
    classKey: "townhouse",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("", 315 - 95, 101 + 54, 44, 54)
                    .add_sale_sign(500, 314 - (315 + 11), 99.1 - (101 + 54))
            ],
        }
    ]
}
addProperty(townhouse);

export const house: property = {
    buySelected: false,
    elsewhere: true,
    key: "house",
    classKey: "house",
    property_parts: [
        {
            nameKey: "property_part_house",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("", 365 - 95, 101 + 54, 44, 54)
                    .add_sale_sign(2000, 364 - (365 + 11), 99.1 - (101 + 54))
            ],
        }
    ]
}
addProperty(house);

export const farm1: property = {
    buySelected: false,
    key: "farm1",
    classKey: "farm",
    elsewhere: false,
    property_parts: [{
        nameKey: "property_part_house",
        damageClass: "farmHouse",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-house", 516 - 109, 406, 49, 28)
                .raise("farm-house-raised", 0)
                .move_relative(248 - 516, 316 - 406).damage_class()
        ],


    }, {
        nameKey: "property_part_cowshed",
        damageClass: "cowShed",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("cow-shed", 391 - 109, 405, 80, 32)
                .move_relative(175 - 391, 339 - 405).damage_class(true),
        ],
    },

    {
        nameKey: "property_part_farm_pump",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("water-pump", 76 + 97 - 109, 68 + 335, 58, 29).requiresPump()
        ],
    },

    {
        nameKey: "property_part_farm_outline",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-outline-1", 117 - 109, 335.3, 487.1, 103.8).requiresOwnership(),
        ],

    },

    ]
}
addProperty(farm1);

export const farm2: property = {
    buySelected: false,
    key: "farm2",
    classKey: "farm",
    elsewhere: false,
    property_parts: [{
        nameKey: "property_part_house",
        damageClass: "farmHouse",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-house", 562 - 109, 382, 49, 28)
                .raise("farm-house-raised", 0)
                .move_relative(352 - 562, 315 - 382).damage_class()
        ],



    }, {
        nameKey: "property_part_cowshed",
        damageClass: "cowShed",
        raiseSelected: false,
        moveSelected: false,
        css: [

            new property_part_css("cow-shed", 438 - 109, 380, 80, 32)
                .move_relative(283 - 438, 339 - 380).damage_class(true),
        ],
    },

    {
        nameKey: "property_part_farmoutline-2",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("water-pump", 62 + 237 - 109, 5 + 335, 58, 29).requiresPump()
        ],

    },

    {
        nameKey: "property_part_farm_outline",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-outline-2", 187.51 - 109, 335.3, 487.1, 87).requiresOwnership(),
        ],

    },


    ]
}
addProperty(farm2);

export const marae: property = {
    buySelected: false,
    elsewhere: false,
    key: "marae",
    classKey: "marae",
    property_parts: [
        {
            nameKey: "property_part_wharenui",
            damageClass: "whareNui",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("wharenui", 703 - 109, 381, 69, 37)
                    .raise("wharenui-raised", 0).move_relative(949.93 - 703, 158.26 - 381)
            ],
        },
        {
            nameKey: "property_part_wharekai",
            damageClass: "whareKai",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("wharekai", 975 - 109, 385, 49.59, 26.57).move_relative(1034 - 975, 198 - 385)
            ],
        },

        {
            nameKey: "property_part_urupā",
            damageClass: "urupa",
            raiseSelected: false,
            moveSelected: false,


            css: [
                new property_part_css("urupa", 767 - 109, 307, 78.81, 18.6)
                    .move_relative(0, 0, "urupa-moving")
                    .move_relative(996 - 767, 236 - 307)
            ],
        },

        {
            nameKey: "property_part_papakāinga",
            damageClass: "papakainga",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("papakainga", 914 - 109, 339, 23, 31)
                    .raise("papakainga-raised", 0)
                    .move_relative(1076 - 914, 166 - 339)
                    .add_child(28)
            ],
        },

        {
            nameKey: "property_part_outline",
            damageClass: "",
            raiseSelected: false,
            moveSelected: false,
            css: [
                new property_part_css("marae-outline", 774.5 - 109, 180.2, 364.84, 258.3).requiresOwnership(),
            ],
        },

    ]
}
addProperty(marae);


export const atRiskFarm1: property = {
    buySelected: false,
    key: "atRiskFarm1",
    classKey: "atRiskFarm",
    elsewhere: false,
    property_parts: [{
        nameKey: "property_part_house",
        damageClass: "atRiskFarmHouse",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-house", 371 - 109, 221, 49, 28).raise("farm-house-raised", 0)
                .add_sale_sign(3000, 418 - 371, 277 - 221).damage_class()

        ],


    },

    {
        nameKey: "property_part_cowshed",
        damageClass: "atRiskCowShed",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("cow-shed", 251 - 109, 289, 80, 32).move_relative(299 - 251, 253 - 289).damage_class(true)
        ],
    },

    {
        nameKey: "property_part_farm_outline",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-outline-atrisk-1", 216.17 - 109, 238.5, 238.73, 96.8).requiresOwnership(),
        ],

    },

    ]


}

export const atRiskFarm2: property = {
    buySelected: false,
    key: "atRiskFarm2",
    classKey: "atRiskFarm",
    elsewhere: false,
    property_parts: [{
        nameKey: "property_part_house",
        damageClass: "atRiskFarmHouse",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-house", 462 - 109, 222, 49, 28).raise("farm-house-raised", 0)
                .add_sale_sign(3000, 314 - 462, 277 - 222).damage_class()
        ],


    },

    {
        nameKey: "property_part_cowshed",
        damageClass: "atRiskCowShed",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("cow-shed", 344 - 109, 288, 80, 32).move_relative(299 - 251, 253 - 289).damage_class(true)
        ],


    },

    {
        nameKey: "property_part_farm_outline",
        damageClass: "",
        raiseSelected: false,
        moveSelected: false,
        css: [
            new property_part_css("farm-outline-atrisk-2", 314.27 - 109, 238.5, 223.21, 96.8).requiresOwnership(),
        ],

    },

    ]
}

addProperty(atRiskFarm1);
addProperty(atRiskFarm2);
